import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton } from 'react-native-paper';

import { AddCircleIcon } from '@/assets';
import { GroupsRoute } from '@/features/groups/navigation/groupsRoute';
import { useVerification } from '@/features/verification/providers/useVerification';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import {
  NavigationButton,
  NavigationIconButton
} from '@/navigation/components/NavigationButton';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = { asIcon?: boolean };

export const GroupCreateButton: FC<Props> = ({ asIcon }) => {
  const { colors } = useAppTheme();

  const { t } = useTranslation(LocalizationNameSpace.GROUPS, {
    keyPrefix: 'screens.groups'
  });

  const { ensureVerified, isVerified } = useVerification();

  if (isVerified) {
    if (asIcon)
      return (
        <NavigationIconButton
          style={{ marginRight: 8 }}
          screen={GroupsRoute.GroupEditor}
          icon={() => (
            <AddCircleIcon width={32} height={32} fill={colors.primary} />
          )}
        />
      );

    return (
      <NavigationButton screen={GroupsRoute.GroupEditor} mode="contained">
        {t('create')}
      </NavigationButton>
    );
  } else {
    if (asIcon)
      return (
        <IconButton
          style={{ marginRight: 8 }}
          icon={() => (
            <AddCircleIcon width={32} height={32} fill={colors.primary} />
          )}
          onPress={() => {
            ensureVerified();
          }}
        />
      );

    return (
      <Button mode="contained" onPress={ensureVerified}>
        {t('create')}
      </Button>
    );
  }
};
